import styled from "styled-components";

export const RadioIconWrapper = styled.label`
  display: flex;
  flex-direction: column;
  width: fit-content;
  gap: 16px;
  align-items: center;
  position: relative;

  &:hover {
    > img {
      filter: grayscale(0%);
    }
  }

  &:has(input:checked) {
    > img {
      filter: grayscale(0%);
    }
  }

  > img {
    cursor: pointer;
    display: block;
    width: 40px;
    height: 40px;
    filter: grayscale(100%);
    transition: filter 0.2s;
  }

  > span {
    color: #2d2d2d;
    text-align: center;
    font-family: Mulish;
    font-size: 14px;
    font-style: normal;
    font-weight: 700;
    line-height: 14px;
  }
`;

export const RadioIconInput = styled.input`
  opacity: 0;
  position: absolute;
  top: 50%;
`;
